import { Directive, ElementRef, HostListener, OnInit, forwardRef } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, Validators } from '@angular/forms';
import { validateCpf } from '../helpers/utils';

export function ValidateCpf() {
  return (c: FormControl): Validators => {
    const err = {
      cpfPattern: true
    };
    return c.value && !validateCpf(c.value) ? err : null;
  };
}

@Directive({
  selector: '[cpfPassportMask]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CpfPassportDirective),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CpfPassportDirective),
      multi: true
    }
  ]
})
export class CpfPassportDirective implements OnInit, ControlValueAccessor {

  public onChangeCallback = (_: any) => { };
  @HostListener('blur', ['$event'])
  public onTouchCallback = () => { };
  validateFn: any = () => { };

  constructor(private _elementRef: ElementRef) { }

  ngOnInit() {
    const cleanValue: string = this._cleanValue(this._elementRef.nativeElement.value);
    this._applyValueChanges(cleanValue);
  }

  @HostListener('input')
  onKeydown(): void {
    const cleanValue: string = this._cleanValue(this._elementRef.nativeElement.value);
    this._applyValueChanges(cleanValue);
  }

  public writeValue(modelValue: string): void {
    if (modelValue === null || modelValue === undefined) {
      this._elementRef.nativeElement.value = '';
      return;
    }

    const cleanValue: string = this._cleanValue(modelValue);
    this._applyValueChanges(cleanValue);
  }

  public registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouchCallback = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this._elementRef.nativeElement.disabled = isDisabled;
  }

  public _hasLetters(value: string): boolean {
    return /[A-Za-z]/.test(value);
  }

  public _applyValueChanges(cleanValue: string): void {
    // Se possuir letras, não aplica a máscara de CPF, apenas exibe o valor limpo
    if (this._hasLetters(cleanValue)) {
      this._elementRef.nativeElement.value = cleanValue;
      this.onChangeCallback(cleanValue);
      return;
    }

    let value = cleanValue.trim().replace(/[^0-9]$/, '');
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    this._elementRef.nativeElement.value = value;
    this.onChangeCallback(cleanValue);
  }

  public _cleanValue(viewValue: string): string {
    const alphaNumeric = viewValue.replace(/[^0-9A-Za-z]/g, '').toUpperCase();

    if (this._hasLetters(alphaNumeric)) {
      // Com letras: máximo de 9 caracteres, sem máscara
      return alphaNumeric.slice(0, 9);
    }

    // Sem letras: comportamento original (apenas dígitos, máximo 11)
    return alphaNumeric.replace(/[^\d]/g, '').slice(0, 11);
  }

  validate(c: FormControl) {
    if (c.value && !this._hasLetters(c.value)) {
      this.validateFn = ValidateCpf();
      return this.validateFn(c);
    }

    // Com letras, não aplica validação de CPF
    this.validateFn = () => null;
    return null;
  }

}